import React from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { TextField } from '@mui/material';
import styles from './TextFieldFilter.module.css';

export const TextFieldFilter = (props) => {
  const {
    label,
    field,
    form: { setFieldValue },
    onChange,
  } = props;

  const handleChange = (event) => {
    setFieldValue(field.name, event.target.value);
    onChange(event.target.value);
  };

  return (
    <TextField
      id={field.name}
      label={label}
      variant="outlined"
      size="small"
      className={styles.textField}
      onChange={handleChange}
    />
  );
};

TextFieldFilter.propTypes = {
  label: Type.string.isRequired,
  field: Type.shape({
    name: Type.string.isRequired,
    value: Type.string,
  }).isRequired,
  form: Type.shape({
    setFieldValue: Type.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    touched: Type.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    errors: Type.object,
  }).isRequired,
  onChange: Type.func,
};

TextFieldFilter.defaultProps = {
  onChange: noop,
};
